import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    scoreLeft: {
        justifyContent: "center",
        float: "left",
        display: "table-cell",
    },

    pointsRed: {
        fontSize: 40,
        display: "flex",
        color: "red",
        alignItems: "center",
        justifyContent: "center",
    },

    penaltyRed: {
        fontSize: 25,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "red",
        marginTop: "-2%",
    },

    scoreRight: {
        justifyContent: "center",
        float: "left",
        display: "table-cell",
    },
    pointsBlue: {
        fontSize: 40,
        display: "flex",
        alignItems: "center",
        color: "blue",
        justifyContent: "center",
    },

    penaltyBlue: {
        fontSize: 25,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "blue",
        marginTop: "-2%",
    },
}));

export { useStyles };
